<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30 7.5L2.5 22.5L30 37.5L52.5 25.225V42.5H57.5V22.5M12.5 32.95V42.95L30 52.5L47.5 42.95V32.95L30 42.5L12.5 32.95Z"
      fill="black"
    />
  </svg>
</template>
